import '../../util/string';
import { CircularProgress, Fab, Tooltip, Typography, InputLabel, Select, MenuItem } from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Moment from 'moment';
import React, { forwardRef, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import QueryString from 'querystring';
import { useHistory } from 'react-router-dom';
import Url from 'url';
import join from 'url-join';
import axios from '../../axios-default';
import { postTraceLog } from '../../store/TraceLog/tracelog.reducer';
//Components
import SideNav from '../../components/Admin/SideNav';
import { ApiServerUrl } from '../../config.json';
import { easySnackbar } from '../../store/Noti/noti.actions';
import { getFromObj } from '../../util/lang';
import { Edit as EditIcon, Undo as UndoIcon, Add as AddIcon, EmojiPeople as EmojiPeopleIcon } from '@material-ui/icons';
import Modal from '../../components/Modal/modal';
import Add from '@material-ui/icons/Add';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import MaterialTable from 'material-table';
import { getWebAbsPath } from '../../util/path';
import TextField from '@material-ui/core/TextField';
import useAdmin from '../../hooks/useAdmin';

const TableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
const PLATFORM = 'dashboard';
const MODULE = 'cases';
const ACTION = 'rollback';

const CaseStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',
        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

const Columns = [
    {
        field: 'patient_id',
        title: 'Patient ID',
        searchable: true,
    },
    {
        field: 'case_id',
        title: 'Case ID',
        searchable: true,
    },
    {
        field: 'profile_pic',
        title: 'Profile',
        searchable: false,
        render: ({ profile_pic, gender }) => (
            <img
                alt={gender}
                style={{ width: 50 }}
                src={profile_pic}
                onError={(e) => {
                    let u = Url.parse(e.target.src);
                    e.target.src =
                        u.pathname === '/' || u.pathname.startsWith('/img')
                            ? ''
                            : gender === 'M'
                              ? getWebAbsPath('/img/maleIcon.png')
                              : gender === 'F'
                                ? getWebAbsPath('/img/femaleIcon.png')
                                : getWebAbsPath('/img/otherIcon.png');
                }}
            />
        ),
    },
    {
        field: 'case_status',
        title: 'Status',
        searchable: true,
    },
    {
        field: 'package_version',
        title: 'Package Version',
        searchable: false,
    },
    {
        field: 'created_by',
        title: 'Doctor ID',
        searchable: true,
    },
    {
        field: 'first_name',
        title: 'First Name',
        searchable: true,
    },
    {
        field: 'last_name',
        title: 'Last Name',
        searchable: true,
    },
    {
        field: 'approval_date',
        title: 'Approved',
        sorting: false,
        render: ({ approval_date }) => (
            <div style={{ display: 'flex', justifyContent: 'center', margin: '0px 4px', width: 40, height: 40 }}>
                {approval_date ? <CheckIcon /> : <CloseIcon />}
            </div>
        ),
    },
    {
        field: 'case_type',
        title: 'Treatment Option',
        searchable: true,
    },
    {
        field: 'product_name',
        title: 'Product Name',
        searchable: true,
    },
    {
        field: 'created_date',
        title: 'Creation Date',
    },
];

export default function Cases(props) {
    const classes = CaseStyles(),
        dispatch = useDispatch(),
        history = useHistory();

    const [loading, setLoading] = useState(false),
        lastPageSize = useRef(),
        lastPageNo = useRef(0),
        [total, setTotal] = useState(0),
        [editCaseType, setEditCaseType] = useState(''),
        [editCaseTypeTo, setEditCaseTypeTo] = useState(''),
        [editCaseTypeCaseId, setEditCaseTypeCaseId] = useState(0),
        [editCaseCreatedBy, setEditCaseCreatedBy] = useState(0),
        [editCasePackageVersion, setEditCasePackageVersion] = useState(''),
        [changeCaseTypeModalOpen, setChangeCaseTypeModalOpen] = useState(false),
        [createdByError, setCreatedByError] = useState(''),
        [changeCreatedByDoctorId, setChangeCreatedByDoctorId] = useState(0),
        [changeCreatedByCaseId, setChangeCreatedByCaseId] = useState(0),
        [changeCreatedByModalOpen, setChangeCreatedByModalOpen] = useState(false),
        [ProductMatrix, setProductMatrix] = useState([]);

    const { handleCancelCase, allowCaseAction } = useAdmin();

    const createdByFieldRef = useRef(null);
    const changeCaseTypeRef = useRef(null);
    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        async function getProductMatrix() {
            const result = await axios.get(`/productmatrix/`);
            console.log(result);
            return;
        }
        getProductMatrix();
    }, []);

    const handleCaseTypeChange = (e) => {
        const caseTypevalue = e.target.value;
        setEditCaseTypeTo(caseTypevalue);
        changeCaseTypeRef.current = caseTypevalue;
        console.log(changeCaseTypeRef.current);
    };

    const handleCaseTypeSave = useCallback(async () => {
        const role = localStorage.getItem('role') && JSON.parse(localStorage.getItem('role'));

        if (role === 'SADMIN') {
            if (window.confirm('Are you going to change this case type?')) {
                const userInput = window.prompt('Please Input Reason:');
                if (userInput) {
                    try {
                        const { value: changedCaseType } = changeCaseTypeRef.current;
                        const { data: result } = await axios.post(
                            `case/${editCaseTypeCaseId}/${editCaseType}/${changedCaseType}/changetype`,
                            { reason: userInput }
                        );
                        if (result.success) {
                            await dispatch(easySnackbar('Success', 'success', true));
                            reloadPage();
                        } else {
                            console.error(result.message);
                            dispatch(easySnackbar(result.message, 'error'));
                        }
                    } catch (err) {
                        console.error(err);
                        dispatch(easySnackbar(getFromObj(err, 'response.data.message') || err.message || err, 'error'));
                    }
                }
            } else {
                dispatch(easySnackbar('Please Input Reason.', 'error'));
            }
        }
    }, [editCaseType, editCaseTypeCaseId]);

    const reloadPage = () => {
        var historyLoc = history.location.pathname;
        history.push('/blank');
        history.replace(historyLoc);
    };
    const handleChangeCreatedBySave = async () => {
        const { value: createdBy } = createdByFieldRef.current;
        if (createdBy.isBlank()) {
            //setAuthError("Input the fields are required")
            setCreatedByError('Doctor is required');
        } else {
            setCreatedByError('');

            const role = localStorage.getItem('role') && JSON.parse(localStorage.getItem('role'));

            if (role === 'SADMIN') {
                if (window.confirm('Are you going to change this doctor?')) {
                    try {
                        const { data: result } = await axios.post(
                            `case/${changeCreatedByCaseId}/${changeCreatedByDoctorId}/${createdByFieldRef.current.value}/changeCreatedBy`
                        );
                        if (result.success) {
                            await dispatch(easySnackbar('Success', 'success', true));
                            reloadPage();
                        } else {
                            console.error(result.message);
                            dispatch(easySnackbar(result.message, 'error'));
                        }
                    } catch (err) {
                        console.error(err);
                        dispatch(easySnackbar(getFromObj(err, 'response.data.message') || err.message || err, 'error'));
                    }
                }
            }
        }
    };

    function getProductMatrixList() {
        return (
            <>
                <InputLabel>Case ID: {editCaseTypeCaseId}</InputLabel>
                {!!editCasePackageVersion && <InputLabel>Package Version: {editCasePackageVersion}</InputLabel>}
                <InputLabel id="case_type">Case Type</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={editCaseTypeTo}
                    label="treatment Option"
                    onChange={handleCaseTypeChange}
                    inputRef={changeCaseTypeRef}
                >
                    {ProductMatrix.map((pm) => (
                        <MenuItem value={pm.case_type}>{pm.product_name}</MenuItem>
                    ))}
                </Select>
            </>
        );
    }

    const handleEnter = ({ key }) => key == 'Enter' && handleChangeCreatedBySave();

    const Actions = [
        // row => ({,
        (row) =>
            ['SADMIN'].includes(
                localStorage.getItem('role') &&
                    JSON.parse(localStorage.getItem('role')) &&
                    JSON.parse(localStorage.getItem('role'))
            )
                ? {
                      icon: () => <EmojiPeopleIcon />,
                      tooltip: 'Change Doctor ID',
                      onClick: (_, data) => {
                          setChangeCreatedByCaseId(data.case_id);
                          setChangeCreatedByDoctorId(data.created_by);
                          setChangeCreatedByModalOpen(true);
                          //setEditCaseTypeCaseId(data.case_id)
                          //setEditCaseType(data.case_type)
                          //setUndoCaseTypeModalOpen(true)
                      },
                  }
                : null,
        (row) =>
            // (row.org_case_status==="NEXT_SET_REQUEST" || row.org_case_status==="PRODUCTION" ) &&
            row.case_type != 'RETAINER' &&
            ['SADMIN'].includes(
                localStorage.getItem('role') &&
                    JSON.parse(localStorage.getItem('role')) &&
                    JSON.parse(localStorage.getItem('role'))
            )
                ? {
                      //.
                      icon: () => <UndoIcon />,
                      tooltip: 'Rollback Flow',
                      hidden:
                          (row.case_status === 'DRAFT' || row.case_status === 'SUBMITTED') &&
                          row.case_type != 'RETAINER' &&
                          ['SADMIN'].includes(
                              localStorage.getItem('role') &&
                                  JSON.parse(localStorage.getItem('role')) &&
                                  JSON.parse(localStorage.getItem('role'))
                          ),

                      onClick: async (_, data) => {
                          const role = localStorage.getItem('role') && JSON.parse(localStorage.getItem('role'));

                          if (role === 'SADMIN') {
                              try {
                                  // Call the API to get the rollback status
                                  const response = await axios.post(
                                      `case/${data.case_id}/${data.case_status}/getrollbackstatus`
                                  );
                                  const { success, rollbackStatus } = response.data;

                                  if (success) {
                                      const confirmationMessage = `Are you going to rollback this case (Case Id: ${data.case_id})? From current ${data.case_status} back to ${rollbackStatus}?`;

                                      if (window.confirm(confirmationMessage)) {
                                          const userInput = window.prompt('Please Input Rollback Reason:');

                                          if (userInput) {
                                              dispatch(
                                                  postTraceLog({
                                                      platform: PLATFORM,
                                                      module: MODULE,
                                                      action: ACTION,
                                                      detail: JSON.parse(
                                                          `{"FromStatus": "${data.case_status}", "BackStatus": "${rollbackStatus}", "Reason": "${userInput}"}`
                                                      ),
                                                      para1: `${data.case_id}`,
                                                      para2: '',
                                                      para3: '',
                                                      para4: '',
                                                      para5: '',
                                                  })
                                              );
                                              try {
                                                  const { data: result } = await axios.post(
                                                      `case/${data.case_id}/${data.case_status}/rollback`
                                                  );
                                                  if (result.success) {
                                                      await dispatch(easySnackbar('Success', 'success', true));
                                                      reloadPage();
                                                  } else {
                                                      console.error(result.message);
                                                      dispatch(easySnackbar(result.message, 'error'));
                                                  }
                                              } catch (err) {
                                                  console.error(err);
                                                  dispatch(
                                                      easySnackbar(
                                                          getFromObj(err, 'response.data.message') ||
                                                              err.message ||
                                                              err,
                                                          'error'
                                                      )
                                                  );
                                              }
                                          } else {
                                              dispatch(easySnackbar('Please Input Rollback Reason.', 'error'));
                                          }
                                      }
                                  }
                              } catch (error) {
                                  console.error(error);
                                  dispatch(
                                      easySnackbar(
                                          getFromObj(error, 'response.data.message') || error.message || error,
                                          'error'
                                      )
                                  );
                              }
                          }
                      },
                  }
                : null,

        (row) =>
            row.case_type != 'RETAINER' &&
            ['SADMIN'].includes(localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')))
                ? {
                      icon: () => <EditIcon />,
                      tooltip: 'Edit Treatment Option',
                      onClick: async (_, data) => {
                          if (row.case_type === 'RETAINER') {
                              dispatch(easySnackbar('Cannot change the Retainer type', 'error'));
                              return;
                          }

                          try {
                              const dm = await axios.get(`/productmatrix/changeTreatmentOption/${data.created_by}`);
                              setProductMatrix(dm.data.pm);
                              setEditCaseTypeCaseId(data.case_id);
                              setEditCaseCreatedBy(data.created_by);
                              setEditCaseType(data.case_type);
                              setEditCaseTypeTo(data.case_type);
                              setEditCasePackageVersion(data.package_version);
                              setChangeCaseTypeModalOpen(true);
                          } catch (err) {
                              const errorMsg = err.response ? err.response.data.message : err.message;
                              dispatch(easySnackbar(errorMsg, 'error'));
                              return;
                          }
                      },
                  }
                : null,
        (row) => ({
            icon: () =>
                row.cancel_flag ? (
                    <Typography variant="body1">Cancelled</Typography>
                ) : (
                    <Fab
                        size="small"
                        aria-label="add"
                        style={{
                            backgroundColor: '#ff0000',
                            color: 'white',
                            margin: '0px 4px',
                        }}
                    >
                        <CancelIcon />
                    </Fab>
                ),
            tooltip: row.cancel_flag ? 'Cancelled' : 'Cancel',
            hidden: false,

            onClick: async () => {
                await handleCancelCase(row.case_id, row.cancel_flag);
            },
        }),
    ];

    const dataGetter = async (query) => {
        const { pageSize, page: pageNo, search, orderBy, orderDirection } = query;
        try {
            if (orderBy && orderBy.field.endsWith('_label')) {
                orderBy.field = orderBy.field.slice(0, -6);
            }
            const { data } = await axios.get(
                `case?${QueryString.encode({
                    searchStr: typeof search !== 'string' || String.isBlank(search) ? undefined : search,
                    sortBy: orderBy && orderBy.field,
                    sortDir: orderDirection,
                    statusFilter: 'ALL',
                    pageSize,
                    pageNo,
                    all: 1,
                })}`
            );
            lastPageSize.current = pageSize;
            lastPageNo.current = pageNo;
            setLoading(false);
            return {
                data: data.case
                    .filter((c) => c.case_id >= 1)
                    .map((c) => {
                        return {
                            patient_id: c.patient_id,
                            case_id: c.case_id,
                            profile_pic: c.profile_pic ? join(ApiServerUrl, c.profile_pic) : '',
                            gender: c.gender,
                            first_name: c.first_name,
                            last_name: c.last_name,
                            approval_date: c.approval_date,
                            case_status: c.case_status,
                            org_case_status: c.case_status,
                            created_by: c.created_by,
                            product_name: c.product_name ? c.product_name : c.default_product_name,
                            case_type: c.case_type,
                            created_date: Moment(c.created_date).calendar({
                                sameElse: 'DD MMM YYYY [at] hh:mm A',
                            }),
                            cancel_flag: c.cancel_flag,
                            package_version: c.package_version,
                        };
                    }),
                page: pageNo ?? 0,
                totalCount: data.total ?? 0,
            };
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.replace('/login');
            }
        }
    };

    return (
        <div>
            <SideNav />
            <Grid container className={classes.rootContainer}></Grid>
            <Grid container className={classes.rootContainer} style={{ marginTop: 0 }}>
                {!loading ? (
                    <div style={{ display: 'contents' }}>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <h1
                                    style={{
                                        marginBlockEnd: 0,
                                    }}
                                >
                                    Cases
                                </h1>

                                <hr />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 8 }}>
                                <MaterialTable
                                    title=""
                                    columns={Columns}
                                    actions={allowCaseAction && Actions}
                                    data={dataGetter}
                                    icons={TableIcons}
                                    options={{
                                        initialPage: 0,
                                        emptyRowsWhenPaging: false,
                                        exportButton: true,
                                        exportAllData: true,
                                        debounceInterval: 700,
                                        columnsButton: true,
                                        actionsColumnIndex: -1,
                                        pageSize: 30,
                                        pageSizeOptions: [15, 30, 50],
                                        minBodyHeight: 700,
                                        maxBodyHeight: 1000,
                                    }}
                                />

                                <Modal
                                    className="modal"
                                    modal="CaseType"
                                    title="Change Case Type"
                                    open={changeCaseTypeModalOpen}
                                    handleClose={() => setChangeCaseTypeModalOpen(false)}
                                    handleDataSave={() => handleCaseTypeSave()}
                                    //modalError={this.state.modalError}
                                    submitButton={true}
                                >
                                    <Grid item xs={12} style={{ padding: 4 }}>
                                        {getProductMatrixList(editCaseCreatedBy)}
                                    </Grid>
                                </Modal>
                                <Modal
                                    className="modal"
                                    modal="CreatedBy"
                                    title="Change Created By"
                                    open={changeCreatedByModalOpen}
                                    handleClose={() => setChangeCreatedByModalOpen(false)}
                                    handleDataSave={() => handleChangeCreatedBySave()}
                                    //modalError={this.state.modalError}
                                    submitButton={true}
                                >
                                    <Grid item xs={12} style={{ padding: 4 }}>
                                        <InputLabel> Case ID: {changeCreatedByCaseId}</InputLabel>
                                        <InputLabel id="case_type">Doctor ID</InputLabel>
                                        <TextField
                                            id="created_by"
                                            //className={classNames(classes.textField)}
                                            margin="dense"
                                            variant="outlined"
                                            inputRef={createdByFieldRef}
                                            fullWidth
                                            autoFocus
                                            onKeyDown={handleEnter}
                                            errorText={createdByError}
                                        />
                                    </Grid>
                                </Modal>
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
}
